import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

/** One place to change table / list datetime display across the admin app. */
export const APP_DATETIME_FORMAT = 'dd MMM yyyy, HH:mm';

export const APP_DATE_FORMAT = 'dd MMM yyyy';

@Pipe({
  name: 'appDate',
  standalone: true,
})
export class AppDatePipe implements PipeTransform {
  transform(value: string | Date | number | null | undefined): string {
    if (value == null || value === '') {
      return '—';
    }
    const d = typeof value === 'string' || typeof value === 'number' ? new Date(value) : value;
    if (Number.isNaN(d.getTime())) {
      return '—';
    }
    return formatDate(d, APP_DATETIME_FORMAT, 'en-GB');
  }
}

@Pipe({
  name: 'appDateOnly',
  standalone: true,
})
export class AppDateOnlyPipe implements PipeTransform {
  transform(value: string | Date | number | null | undefined): string {
    if (value == null || value === '') {
      return '—';
    }
    let d: Date;
    if (value instanceof Date) {
      d = value;
    } else if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
      d = new Date(`${value.trim()}T00:00:00`);
    } else {
      d = new Date(value);
    }
    if (Number.isNaN(d.getTime())) {
      return '—';
    }
    return formatDate(d, APP_DATE_FORMAT, 'en-GB');
  }
}
